import Login from "./views/login/Login.js";
import Dashboard from "./views/dashboard/Dashboard";
import DoctorList from "./views/doctorList/doctorList.js";
import EditDoctor from "./views/editDoctor/editDoctor.js";
import DoctorDetails from "./views/doctorDetails/doctorDetails.js";
import Settings from "./views/settings/Settings.js";
import PatientList from "./views/patientList/patientList.js";
import PatientDetails from "./views/PatientDetails/patientInfoDetails.js";
import AddNewSpecialities from "./views/Specialities/addNewSpecialities.js";
import SpecialitiesList from "./views/Specialities/SpecialitiesList.js";
import AddNewUser from "./views/addNewUser/addNewUser.js";
import UserList from "./views/userList/userList.js";
import AppointmentList from "./views/AppointmentList/appointmentList.js";

const routes = [
  { path: "/login", name: "Login", element: Login },
  { path: "/dashboard", name: "Dashboard", element: Dashboard },

  { path: "/PatientList", name: "Patient List", element: PatientList },

  { path: "/AddNewUser", name: "Add New User", element: AddNewUser },
  { path: "/UserList", name: "User List", element: UserList },

  {
    path: "/SpecialityList",
    name: "Speciality List",
    element: SpecialitiesList,
  },
  {
    path: "/AppointmentList",
    name: "Appointment List",
    element: AppointmentList
  },

  {
    path: "/AddNewSpecialities",
    name: "Add New Speciality",
    element: AddNewSpecialities,
  },
  { path: "/EditDoctor", name: "Edit Customer", element: EditDoctor },
  { path: "/doctorList", name: "DoctorList", element: DoctorList },
  {
    path: "/doctorDetails/:id",
    name: "Doctor Details",
    element: DoctorDetails,
  },
  {
    path: "/PatientDetails/:id",
    name: "Patient Details",
    element: PatientDetails,
  },
  { path: "/settings", name: "Settings", element: Settings },
];

export default routes;
